import { Alert, Container, Icon, LinearProgress, Paper, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { formService } from '../_services/form.service';
import { FormStatusEnum } from '../_common/enum/forms/formStatus.enum';

export function FormResult() {
    const navigate = useNavigate();

    const { formId } = useParams<{ formId: string }>();
    const [isLoading, setLoading] = useState(false);
    const _formId = Number(formId);
    const [data, setData] = useState<any>();

    useEffect(() => {
        if (formId) {
            fetchData();
        }
    }, [formId]);

    useEffect(() => {
        if (!isLoading && data && data?.formStatusId == FormStatusEnum.Approved) {
            setTimeout(() => {
                navigate("../");
                window.location.reload();
            }, 5000)
        }
    }, [data]);

    function fetchData() {

        setLoading(true);
        return formService
            .getStatus(_formId)
            .then(
                (json) => {
                    console.log(json);
                    setData(json);
                }
            )
            .finally(() => {
                setLoading(false);
            });
    }

    return (
        <Container maxWidth="sm">
            <Paper sx={{ padding: 3 }}>

                {isLoading && <LinearProgress />}

                {(data && data?.formStatusId == FormStatusEnum.Approved) &&
                    <Alert icon={<Icon>check</Icon>} severity="success">
                        Congratulations! You have successfully completed to form with <strong>{data.completedPercent}% </strong>successful answers!
                    </Alert>
                }

                {(!isLoading && (data && data?.formStatusId != FormStatusEnum.Approved)) &&
                    <Alert icon={<Icon>cancel</Icon>} severity="error">
                        Unforunately, you did not complete the form successfully. <br />You answered <strong>{data.completedPercent}%</strong> answers correctly.
                    </Alert>
                }

                <Typography variant="h6" textAlign="center" color="primary" marginBottom={2}>
                </Typography>

                <Typography style={{ width: "100%", "textAlign": "center" }} textAlign="center" color="primary" marginBottom={2}>
                    {(!isLoading && (data && data?.formStatusId != FormStatusEnum.Approved)) &&
                        <>Please try again</>
                    }
                    {(data && data?.formStatusId == FormStatusEnum.Approved) &&
                        <>You are being redirected</>
                    }
                </Typography>
            </Paper>
        </Container>
    );
};

